export enum InputDataTypes {
    TEXT = 'text',
    CHECKBOX = 'checkbox',
    PASSWORD = 'password',
    HIDDEN = 'hidden',
    TEL = 'tel',
}